// FIXME: DO NOT MIGRATE THIS TO SPA. AFTER SPA MIGRATION, THERE IS NO REASON TO FIRE EVENTS AFTER PAGE LOAD
// AS WE HAVE SPA NAVIGATION
var EventManager = {
  eventNameKeyPrefix: 'pending_event_key_',
  eventDataKeyPrefix: 'pending_event_data_',
  fireEventOnNextPageLoad: function (eventName, data) {
    var setCookie = function (key, value) {
      document.cookie = key + '=' + value + '; Path=/;';
    };
    var uniqueEventId = new Date().getTime().toString();

    console.log('Will fire event on next page load:', 'ID ' + uniqueEventId, eventName, data);

    setCookie(this.getEventNameKey(uniqueEventId), eventName);
    setCookie(this.getEventDataKey(uniqueEventId), JSON.stringify(data));
  },
  getEventNameKey: function (eventId) {
    return this.eventNameKeyPrefix + eventId;
  },
  getEventDataKey: function (eventId) {
    return this.eventDataKeyPrefix + eventId;
  },
};

window.EventManager = EventManager;



export default function processAnalyticsEvents() {
  // Taken from https://stackoverflow.com/a/21125098/4562693

  var getCookie = function (name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match && match.length > 2) {
      return match[2];
    }
    return null;
  };

  // Taken from https://stackoverflow.com/a/2144404/4562693
  var removeCookie = function (key) {
    document.cookie = key + '=;  Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  };

  // Taken from https://stackoverflow.com/a/28944369/4562693
  // altered to return only the left side of =
  var getCookiesMatchingPrefix = function (prefix) {
    return document.cookie
      .split(';')
      .filter(function (c) {
        return c.trim().indexOf(prefix) === 0;
      })
      .filter(function (c) {
        return c.indexOf('=') > 0;
      })
      .map(function (c) {
        return c.trim().split('=')[0];
      });
  };

  var cookiesMatchingPrefix = getCookiesMatchingPrefix(EventManager.eventNameKeyPrefix);

  for (var i = 0; i < cookiesMatchingPrefix.length; i++) {
    var eventNameKey = cookiesMatchingPrefix[i];
    var eventDataKey = eventNameKey.replace(EventManager.eventNameKeyPrefix, EventManager.eventDataKeyPrefix);

    var eventName = getCookie(eventNameKey);
    var eventDataJson = getCookie(eventDataKey);
    if (eventName && eventDataJson) {
      var eventData = JSON.parse(eventDataJson);

      console.log('Firing event with key:', eventNameKey, 'Event Name:', eventName, 'Event Data:', eventData);

      // GTM
      window.dataLayer &&
        window.dataLayer.push(
          Object.assign(
            {},
            {
              event: eventName === 'User_Registered' || eventName === 'Create_Page' ? eventName + '_GTM' : eventName,
            },
            eventData
          )
        );
    }

    removeCookie(eventNameKey);
    removeCookie(eventDataKey);
  }
}
